import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Segment } from "semantic-ui-react";
import { parseString } from "xml2js";
import _ from "lodash";
import AppMenu from "../../components/pages/AppMenu";
import settings from "../../settings";
import api from "../../api";
import { expireSession } from "../../actions/auth";
import getOfflineDriverLicenseDetail from "./OfflineDriverLicenseDetail";
import { getErrorMessage } from "../messages/errorMessages";

class OfflineDriverLicenseSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crimRes: undefined,
      pickedUser: "",
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }
  loadData = (props) => {
    const pickedUser = localStorage.offlinePickedUser;
    const params = {
      view: "mvr",
      month: new Date().getMonth() + 1,
      sserver: settings.appName,
      userID: props.user.userid,
      pickedUser,
      savedResultID: localStorage.offlineResultId,
      sessionID: localStorage.getItem("sessionID"),
    };

    api.lp.getActivitiesView(params).then((res) => {
      parseString(res.data, { async: false }, (err, result) => {
        const root = Object.keys(result)[0];
        if (root === "errors") {
          if (_.get(result, `${root}.error[0].$.errType`) === "unauthorized") {
            localStorage.errorMessage = _.get(
              result,
              `${root}.error[0].errMsg[0]`,
              ""
            );
            const errorMessage = getErrorMessage(
              localStorage.errorMessage,
              _.get(result, `${root}.error[0].errMsg[0]`, "")
            );
            this.props.expireSession(errorMessage);
          }
        } else {
          const crimRes = getOfflineDriverLicenseDetail({ data: result });
          if (this.state) {
            this.setState({ crimRes, pickedUser });
          } else {
            this.state = { crimRes, pickedUser };
          }
        }
      });
    });
    if (this.state) {
      this.setState({ pickedUser });
    }
  };

  render() {
    return (
      <div>
        <div className="col-lg-12 col-sm-12">
          <div className="row">
            <AppMenu
              uiData={this.props.uiData}
              userAccount={this.props.userAccount}
              history={this.props.history}
            />
            <Segment key="tabContent1" attached>
              <Grid stackable>
                <Grid.Row>
                  <Grid.Column>
                    <span
                      className={"picked-user"}
                    >{`UserName: ${this.state.pickedUser}`}</span>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>{this.state.crimRes}</Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, { expireSession })(
  OfflineDriverLicenseSearch
);



// WEBPACK FOOTER //
// ./src/components/myaccount/OfflineDriverLicenseSearch.js